import { z } from "zod";
import { withPathParams } from "../../../../shared/consts/hoc";
import { PayrollBatchId } from "../../../../shared/schema/schema";
import PayrollAuditPage from "./PayrollAuditPage";

const pathParamsSchema = z.object({
  id: z.string().transform((x) => PayrollBatchId.parse(parseInt(x))),
});

type PayrollAuditRouteProps = {
  pathParams: z.infer<typeof pathParamsSchema>;
};

const PayrollAuditRoute = (props: PayrollAuditRouteProps) => {
  return <PayrollAuditPage payrollBatchId={props.pathParams.id} />;
};

export default withPathParams(PayrollAuditRoute, pathParamsSchema);
